<div name="search" id="search">
    <!-- ToDo: Re-factor names, id's, and classes to quick-search prefix. -->
    <div class="search-section"
         [ngClass]="{'slide-in': showSearch, 'slide-out': !showSearch && active}">
        <div class="search-panel card">
            <div class="card-header">
                <div class="ws-flex-container-horizontal-wrap ws-flex-justify-content-space-between">
                    <div class="col-lg-3 position-relative">
                        <div class="card-title d-flex align-items-center my-0 h4">
                            <i class="fa fa-search ms-3"></i>
                            <h3 class="m-0 ms-2">Search</h3>
                        </div>
                    </div>
                    <div class="float-end">
                        <button type="button"
                                class="ace-btn has-icon btn-text icon-dark fa fa-save mb-0"
                                aria-label="Save Search"
                                aria-hidden="true"
                                data-qa="save-search-button"
                                title="Save"
                                (click)="saveSearch()">
                        </button>
                        <button type="button"
                                class="ace-btn has-icon btn-text icon-dark fa fa-list mb-0"
                                aria-label="Toggle Criteria"
                                aria-hidden="true"
                                data-qa="toggle-criteria-button"
                                title="Criteria"
                                [ngClass]="{ 'active': showCriteria }"
                                (click)="toggleCriteria()">
                        </button>
                        <button type="button"
                                class="ace-btn has-icon btn-text icon-dark fa fa-undo mb-0"
                                aria-label="Reset Search"
                                aria-hidden="true"
                                data-qa="reset-search-button"
                                title="Reset"
                                (click)="resetClicked()">
                        </button>
                        <button type="button"
                                class="ace-btn has-icon btn-text icon-dark fa fa-arrow-right mb-0"
                                aria-label="Dismiss Search"
                                aria-hidden="true"
                                data-qa="dismiss-search-button"
                                title="Collapse"
                                (click)="toggleSearch($event)">
                        </button>
                    </div>
                </div>
            </div>
            <div class="search-body card-body">
                <div class="search-criteria-container" [ngClass]="{ 'show': showCriteria }">
                    <quick-search-criteria-panel [(criteria)]="criteria"
                                                 [navigatingFrom]="navigatingFrom"
                                                 [isOpen]="showSearch">
                    </quick-search-criteria-panel>
                </div>
                @if (showResults) {
                    <div class="search-results-container">
                        <quick-search-result (closeSearchPanel)="showSearch = false"></quick-search-result>
                    </div>
                }
            </div>
        </div>
    </div>
    @if (showSearch) {
        <div class="search-overlay"
             data-qa="quick-search-dismiss-overlay"
             (click)="toggleSearch($event)">
        </div>
    }
</div>

